<template>
  <div class="StockRegForm">
    <div class="flex">
      <el-form :model="data" ref="form" :rules="rules" label-width="60px">
        <el-row>
          <el-col :span="16">
            <el-form-item
              label="품목"
              prop="product_id"
              class="custom-form-item"
            >
              <AProductSelector
                size="tiny"
                class="product w-full"
                :value="data.product_name"
                :disabled="isUpdate"
                @select="handleSelectProduct"
              />
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="단위" prop="unit_id" class="custom-form-item">
              <AProductUnitSelector
                v-model="data.unit_id"
                :id="data.product_id"
                disableSizeAmount
              />
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
    </div>
    <div v-show="!isSetBreak">
      <el-radio v-model="type_flag" label="I">수량 추가</el-radio>
      <el-radio v-model="type_flag" label="O">수량 감소</el-radio>
      <el-radio v-model="type_flag" label="M">수량 맞춤</el-radio>
    </div>
    <div class="row-splitter flex">
      <div class="inline">
        <ANumberKey @completed="handleCompleted" />
      </div>
      <div class="inline">
        <span style="width: 50px; line-height: 32px; margin-left: 5px;"
          >거래일</span
        >
        <ADatePicker
          v-model="deal_date"
          style="width:153px; margin-left: 11px;"
          :disabled="isUpdate"
          :options="pickerOptions"
        />
        <div
          class="inline"
          style="width: 50px; line-height: 32px; margin-left: 5px;"
        >
          비 고
        </div>
        <div class="inline">
          <el-input v-model="desc" style="width:153px;" />
        </div>
      </div>
    </div>
    <div class="row-splitter">
      <el-button type="primary" class="button" @click="handleClickRegister">
        {{ this.isUpdate ? "수량 수정" : "수량 등록" }}
      </el-button>
      <el-button class="button" @click="closeDialog"
        >{{ $t("button.close") }}(Esc)</el-button
      >
    </div>
  </div>
</template>

<script>
export default {
  name: "StockRegForm",
  data() {
    return {
      rules: {
        product_id: [
          {
            required: true,
            message: "품목을 선택하세요.",
            // trigger: ["blur", "change"],
          },
        ],
        unit_id: [
          {
            required: true,
            message: "단위를 선택하세요.",
            trigger: ["blur", "change"],
          },
        ],
        product_amount: [
          { required: true, message: "수량을 입력하세요.", trigger: "blur" },
        ],
        task_id: [
          { required: true, message: "작업을 선택하세요.", trigger: "blur" },
        ],
      },
      type_flag: "I",
      amount: 0,
      desc: "",
      deal_date: this.util.getDate(0),
      pickerOptions: {
        disabledDate(time) {
          return time.getTime() > Date.now();
        },
      },
    };
  },
  props: {
    data: {
      type: Object,
      default: function() {
        return {
          product_id: null,
          product_name: "",
          unit_id: null,
        };
      },
    },
    isUpdate: {
      type: Boolean,
      default: false,
    },
    isSetBreak: {
      type: Boolean,
      default: false,
    },
  },
  mounted() {
    if (this.isUpdate || this.isSetBreak) this.deal_date = this.data.deal_date;
  },
  methods: {
    doRegister() {
      let param = Object.assign({}, this.data);
      if (this.isUpdate) param.id = this.data.id;
      param.type_flag = this.type_flag;
      param.amount = this.amount;
      param.deal_date = this.deal_date;
      param.desc = this.desc;
      let api = this.isUpdate ? this.api.updateStock : this.api.createStcok;
      if (this.isSetBreak) api = this.api.createStockSetBreak;
      api(param).then((res) => {
        if (res.error !== this.system.noError) {
          this.loading = false;
          this.util.notify_error(this, "자재", res.message);
          return;
        }
        this.$emit("completed", res.data);
      });
    },
    closeDialog() {
      this.$emit("completed");
    },
    handleSelectProduct(p) {
      if (typeof p === "object") {
        this.data.product_name = p.name;
        this.data.product_id = p.id;
      } else {
        if (p !== "") {
          this.data.product_name = p;
          this.data.product_id = null;
        }
      }
    },
    handleClickRegister() {
      if (this.amount < 1) {
        this.util.notify(
          this,
          "w",
          this.$t("lang.stock"),
          "수량을 입력해 주세요."
        );
        return;
      }
      if (!this.data.product_id) {
        this.util.notify(this, "w", "품목", "품목을 선택해 주세요.");
        return;
      }
      let msg = this.isUpdate ? "수정" : "등록";
      this.util.confirm(
        this,
        this.$t("lang.stock"),
        msg + "하시겠습니까?",
        this.doRegister
      );
    },
    handleCompleted(val) {
      this.amount = val;
    },
  },
};
</script>

<style lang="scss" scoped>
.button {
  width: 46%;
}
.flex {
  > div:not(:first-child) {
    padding-left: 10px;
  }
}
.option {
  float: left;
  width: 50% !important;
}
</style>
